// WithMessagePinData.js
import { connect } from 'react-redux';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import WithMessagePinData from '../component/WithMessagePinData.jsx';

import fetchFeeds from '../action/fetchFeeds.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import { PROFILE_FEED_REMOTE_CONFIG_KEY_MAP } from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';
import { getFeedNameType } from '../resource/feedUtils.js';

const mapStateToProps = (state, { messageId, profileListType }) => {
  const meId = getMeData(state, 'id');
  const senderId = getMessageData(state, messageId, 'senderId');
  const feedRemoteConfigKey =
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[profileListType];
  const { feedNameWithQuery } = senderId
    ? getSelectedQueryOptionObject(
        state,
        getFeedName(state, feedRemoteConfigKey, '{USER_ID}', senderId),
        getSelectedFeedQueryOptions(state, feedRemoteConfigKey, undefined),
        getRemoteConfigData(
          state,
          `${feedRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
        )?.[0]
      )
    : {};
  return {
    meId,
    messageId,
    feedNameWithQuery,
    pinnedItemIds: getListData(
      state,
      [
        'home',
        getFeedNameType({ feedName: feedNameWithQuery }),
        feedNameWithQuery,
        'pinned',
      ],
      'itemIds'
    ),
    senderId,
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(
      state,
      meId,
      profileListType
    ),
    isFetched: getNetworkingData(
      state,
      [
        'home',
        getFeedNameType({ feedName: feedNameWithQuery }),
        feedNameWithQuery,
        1,
      ],
      'isFetched'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
    updateProfileFeedUnixTimestamp: ({ unixTimestamp }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['profileFeed'],
          data: {
            unixTimestamp,
          },
        },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithMessagePinData);
